// extracted by mini-css-extract-plugin
export default {"draft-panel":"lsf-draft-panel","draft-panel__toggle":"lsf-draft-panel__toggle"};
    if(module.hot) {
      // 1637785522121
      var cssReload = require("/Users/nicholasrq/Git/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  